class MdcLayoutGrid extends HTMLElement {

  constructor() {
    super();
  }

  connectedCallback() {
  }

  disconnectedCallback() {
  }
};

customElements.define("mdc-layout-grid", MdcLayoutGrid);
